import { Checkbox, DisableFocusContainer } from '@vw-marketing/us-components';
import React from 'react';
import { StyledFilterAttributeWrapper } from './styled';

export interface FilterCheckBoxProps {
  readonly label: React.ReactNode;
  readonly value: string;
  readonly onClick?: () => void;
  readonly checked?: boolean;
  readonly isDisabled?: boolean;
  readonly highlight?: boolean;
}

export const FilterCheckBox: React.FC<FilterCheckBoxProps> = (props) => {
  const { label, value, onClick, checked, isDisabled, highlight } = props;

  return (
    <StyledFilterAttributeWrapper isDisabled={isDisabled} highlight={highlight} className="filter-checkbox">
      <DisableFocusContainer className="disable-focus">
        <Checkbox
          value={value}
          label={label}
          onClick={onClick}
          checked={checked}
          disabled={isDisabled}
        />
      </DisableFocusContainer>
    </StyledFilterAttributeWrapper>
  );
};
